/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Перечисление, определяющее тип цели для квеста.
 * @export
 * @enum {string}
 */
export enum FxIdDomainCrossPlayQuestTargetType {
    Unspecified = 0,
    CurrentValue = 1,
    CumulativeValue = 2,
    EventCount = 3,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainCrossPlayQuestTargetType(value: any): boolean {
    for (const key in FxIdDomainCrossPlayQuestTargetType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainCrossPlayQuestTargetType, key)) {
            if (FxIdDomainCrossPlayQuestTargetType[key as keyof typeof FxIdDomainCrossPlayQuestTargetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainCrossPlayQuestTargetTypeFromJSON(json: any): FxIdDomainCrossPlayQuestTargetType {
    return FxIdDomainCrossPlayQuestTargetTypeFromJSONTyped(json, false);
}

export function FxIdDomainCrossPlayQuestTargetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainCrossPlayQuestTargetType {
    return json as FxIdDomainCrossPlayQuestTargetType;
}

export function FxIdDomainCrossPlayQuestTargetTypeToJSON(value?: FxIdDomainCrossPlayQuestTargetType | null): any {
    return value as any;
}

export function FxIdDomainCrossPlayQuestTargetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainCrossPlayQuestTargetType {
    return value as FxIdDomainCrossPlayQuestTargetType;
}

